import { useMemo } from 'react';
import { getLocale } from '../../../locales';

export default function useLocale(lang, scope) {
  return useMemo(() => {
    const locale = getLocale(lang);
    return scope ? (locale[scope] || {}) : locale;
  }, [lang, scope]);
}
